/**
 * The contributor agreement.
 *
 * Kept in one place so signup and the re-acceptance step show exactly the
 * same wording — a version number against two different texts would be
 * worthless as a record of what somebody agreed to.
 */
export const TERMS_VERSION = "1.1";

export function ContributorTerms() {
  return (
    <div className="terms-box">
      <h3>01 · What you're agreeing to</h3>
      <p>
        By joining the Inputry Contributor Network you agree to record short,
        original voice note reactions to the responses shown to you, and to submit them
        through this app.
      </p>

      <h3>02 · Payment</h3>
      <ul>
        <li>
          You are paid <strong>per accepted voice note</strong> — the current rate is
          always shown on your dashboard.
        </li>
        <li>
          A note is "accepted" once our team has reviewed it and confirmed it meets the
          content guidelines below.
        </li>
        <li>Payouts are sent to your PayPal address once you reach the threshold.</li>
        <li>Duplicate, silent, off-topic or unintelligible notes are not paid.</li>
      </ul>

      <h3>03 · Content guidelines</h3>
      <ul>
        <li>Keep it real — react in your own words and your own voice.</li>
        <li>No hate speech, harassment, explicit content or personal attacks.</li>
        <li>Keep each note roughly 10–40 seconds.</li>
        <li>Background noise is fine, but we should be able to hear you clearly.</li>
        <li>
          Do not use AI voice generators or voice cloning. Submit a natural human
          recording that does not sound AI-generated.
        </li>
        <li>
          Record in a natural, everyday speaking voice — it shouldn't sound like a
          studio recording.
        </li>
      </ul>

      <h3>04 · Usage rights</h3>
      <p>
        You grant Inputry a non-exclusive licence to use, edit and broadcast your
        voice notes across our shows, podcasts and social channels.
      </p>

      <h3>05 · Your data</h3>
      <p>
        We use your name, email and WhatsApp number to register you, verify submissions
        and process payment.
      </p>

      <h3>06 · Ending your participation</h3>
      <p>
        You can stop contributing at any time. Any notes already accepted before you
        leave will still be paid.
      </p>
    </div>
  );
}
